export default __webpack_public_path__ + "static/media/hour-glass.adcc5b64.svg";